import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=b6371d62"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardAdmin.vue?vue&type=style&index=0&id=b6371d62&prod&lang=scss"
import style1 from "./DashboardAdmin.vue?vue&type=style&index=1&id=b6371d62&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports